import { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';
import { use2FALogin } from '../hooks/use2FALogin';

export default function TwoFALoginPage() {
  const pendingToken = useAuthStore((s) => s.pendingTwoFAToken);

  // No pending token means the user navigated here directly — send to login
  if (!pendingToken) return <Navigate to="/login" replace />;

  return <TwoFALoginForm />;
}

// Separate inner component so the hook only mounts when pendingToken exists
const TwoFALoginForm = memo(function TwoFALoginForm() {
  const { code, error, loading, handleChange, handleSubmit, handleCancel } = use2FALogin();

  return (
    <div className="auth-page">
      <div className="auth-header">
        <h1 className="auth-title">two-factor auth</h1>
        <p className="auth-subtitle">
          Enter the 6-digit code from your authenticator app.
        </p>
      </div>

      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <div className="form-field">
          <label className="form-label" htmlFor="totp-code">authenticator code</label>
          <input
            id="totp-code"
            className={`form-input tfa-code-input${error ? ' form-input--error' : ''}`}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="000000"
            value={code}
            onChange={handleChange}
            disabled={loading}
            maxLength={6}
            autoFocus
            aria-describedby={error ? 'totp-error' : undefined}
            aria-invalid={!!error}
          />
          {error && (
            <span id="totp-error" className="form-error" role="alert">{error}</span>
          )}
        </div>

        <button
          className="btn btn--primary auth-submit-btn"
          type="submit"
          disabled={loading || code.length !== 6}
          aria-busy={loading}
        >
          {loading ? (
            <span className="auth-btn-loading">
              <span className="auth-spinner" />
              verifying…
            </span>
          ) : (
            'verify'
          )}
        </button>
      </form>

      <p className="auth-footer">
        <button className="auth-text-btn" onClick={handleCancel} type="button">
          ← back to sign in
        </button>
      </p>
    </div>
  );
});
